module.exports = __webpack_public_path__ + "media/images/pepsi_digin_day/map-world-9401c8568fecd45a7b7fe76c38893ce1.png";